// 必須是第一個 import：constants 裡有許多在模組載入時就呼叫 t() 求值的對照表
// （例如 ECOURSE_TYPE_TEXT、COURSE_STATUS_LABEL），i18n 若還沒 init，t() 會回空字串且不會再重算。
// 只靠 TranslationProvider 間接載入時，載入順序取決於 App 的 import 鏈，任何 barrel 牽到 constants 就會壞。
import './locales/i18n';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// contexts
import { SettingsProvider, CollapseDrawerProvider } from '@onedesign/ui';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import 'react-toastify/dist/ReactToastify.css';

// config
import { defaultSettings } from './config';
import colorPresets from './theme/colorPresets';

import 'simplebar/src/simplebar.css';

import App from './App';
import initAPM from './elasticAPM';
(window as any).global = window;
initAPM();

ReactDOM.render(
  <HelmetProvider>
    <SettingsProvider
      colorPresets={colorPresets}
      defaultSettings={defaultSettings}
    >
      <CollapseDrawerProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </LocalizationProvider>
      </CollapseDrawerProvider>
    </SettingsProvider>
  </HelmetProvider>,
  document.getElementById('root'),
);
